import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

import { getApiErrorMessage } from '@/utils/handleApiError';

type FormErrorAlertProps = {
  error?: unknown;
  fallbackKey?: string;
};

/** Inline form-level error from a mutation/query `error` value — no parallel useState. */
const FormErrorAlert = ({
  error,
  fallbackKey = 'ERROR_MESSAGE',
}: FormErrorAlertProps) => {
  const { t } = useTranslation();

  if (error == null || error === '') {
    return null;
  }

  const title =
    typeof error === 'string'
      ? error
      : getApiErrorMessage(error, t(fallbackKey));

  if (!title) {
    return null;
  }

  return <Alert type="error" showIcon={false} title={title} />;
};

export default FormErrorAlert;
